exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vdp-datepicker__calendar{bottom:100%}.fecha-texto{color:#989898!important}.contenedor-presu{overflow-y:scroll;height:calc(100vh - 250px)}.spinner--mikepad{position:absolute!important;top:50%;left:50%;transform:translateX(-50%)}.spinner-inner .binding,.spinner-inner .pad{border-color:red!important}.spinner-inner .line{border-color:#fff!important}.modal-spinner{display:block;position:fixed;z-index:999999;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:rgba(0,0,0,.4)}", ""]);

// exports
